<div
    #wrapper
    role="group"
    class="se-date-range"
    [attr.aria-labelledby]="formField?.getLabelId()"
    (click)="onContainerClick($event)"
>
    <mat-form-field appearance="outline" class="se-form-field">
        <mat-label>{{ placeholder }}</mat-label>
        <mat-date-range-input
            [formGroup]="form"
            [rangePicker]="picker"
            se-autofocus
            [autofocus]="autofocus"
            [max]="maxSelectableDate"
            (focusin)="onFocusIn($event)"
            (focusout)="onFocusOut($event)"
            (keydown.enter)="onEnter()"
        >
            <input matStartDate formControlName="from" [placeholder]="placeholderStartDate" />
            <input matEndDate formControlName="to" [placeholder]="placeholderEndDate" />
        </mat-date-range-input>
        @if (showHint) {
            <mat-hint>{{ getDateFormat() }} – {{ getDateFormat() }}</mat-hint>
        }
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        @if (hasStartDateError()) {
            <mat-error>Invalid start date</mat-error>
        }
        @if (hasEndDateError()) {
            <mat-error>Invalid end date</mat-error>
        }
    </mat-form-field>
    <div class="actions" [class.focused]="focused">
        <button
            type="button"
            mat-mini-fab
            color="unthemed"
            aria-label="Empty"
            [disableRipple]="true"
            (click)="reset($event)"
        >
            <mat-icon>close</mat-icon>
        </button>
        <button
            type="button"
            mat-mini-fab
            color="unthemed"
            aria-label="Select interval"
            [disableRipple]="true"
            [matMenuTriggerFor]="dataRangeIntervalMenu"
        >
            <mat-icon>play_arrow</mat-icon>
        </button>
        <mat-menu #dataRangeIntervalMenu="matMenu" yPosition="below" xPosition="after">
            @for (interval of predefiniteIntervals; track $index) {
                <div>
                    <button mat-menu-item class="se-menu-button" (click)="setPredefiniteInterval(interval)">
                        <span>{{ getLabelForInterval(interval) }}</span>
                    </button>
                </div>
            }
        </mat-menu>
    </div>
</div>
